//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import common from "@/utils/common.js";
export default {
  name: "InsureManageList",
  data() {
    return {
      filterForm: {
        companyName: "", // 保险机构
        contactName: "", // 联系人
        businessZoneId: "", //业务区域id
        businessPersonId: "", //业务负责人id
        loginName: "", // 账号
        // pageType: 5,
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      tableData: [],
      businessZoneList: [], //业务区域数据
      zoneProps: {
        value: "id",
        label: "zoneName",
        children: "children",
      },
      checkedZone: [], //选中的业务区域
      dutyPersonList: [],
      dialogResetVisible: false,
      currentData: {},
      resetRules: {
        password: [
          { required: true, message: "请填写6-20位账号密码", trigger: "blur" },
          {
            min: 6,
            max: 20,
            message: "请输入6-20位账号密码",
            trigger: "blur",
          },
        ],
      },
      dialogUpdateVisible: false,
      currentCheckedZone: [],
      currentDutyPersonList: [],
      updateRules: {
        companyName: [
          { required: true, message: "请选择保险机构", trigger: "blur" },
        ],
        businessAddress: [
          { required: true, message: "请填写业务网点", trigger: "blur" },
        ],
        contactName: [
          { required: true, message: "请填写联系人名称", trigger: "blur" },
        ],
        mobile: [
          { required: true, message: "请填写手机号码", trigger: "blur" },
          { validator: common.checkMobile, required: true, trigger: "blur" },
        ],
        subDomain: [
          { required: true, message: "请填写登录地址", trigger: "blur" },
          { trigger: "blur", validator: common.checkSubDomain },
          { min: 2, max: 20, message: "长度在4到20位", trigger: "blur" },
        ],
        businessZoneId: [
          { required: true, message: "请选择业务区域", trigger: "blur" },
        ],
        businessPersonId: [
          { required: true, message: "请选择业务员", trigger: "blur" },
        ],
      },
      oldRowData: {},
    };
  },
  components: {},
  watch: {
    checkedZone(newVal) {
      this.filterForm.businessPersonId = "";
      this.dutyPersonList = [];
      this.filterForm.businessZoneId =
        newVal.length > 0 ? newVal[newVal.length - 1] : "";
      newVal.length > 0 && this.getDutyPerson();
    },
    currentCheckedZone(newVal) {
      this.currentData.businessPersonId = "";
      this.dutyPersonList = [];
      this.currentData.businessZoneId =
        newVal.length > 0 ? newVal[newVal.length - 1] : "";
      newVal.length > 0 && this.getCurrentDutyPerson();
    },
  },
  created() {
    this.getBusinessZoneData();
    this.getCtCountyAccountPage();
  },
  mounted() {},
  methods: {
    //页码切换
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.getCtCountyAccountPage();
    },
    /**
     * @Description: 获取县系统列表
     * @Author: yangsibo
     * @Date: 2022-09-28 19:49:10
     * @return {*}
     */
    async getCtCountyAccountPage() {
      try {
        let { data } = await this.$http.insure.getInsureInfoListByPage({
          ...this.pagination,
          ...this.filterForm,
        });
        this.tableData = data.content;
        this.pagination.total = data.recordTotal;
      } catch (error) {
        console.log(error);
      }
    },
    // 获取业务区域数据
    getBusinessZoneData() {
      this.$http.common.getBusinessZoneList({}).then((res) => {
        this.businessZoneList = res.data;
      });
    },
    // 获取业务负责人
    getDutyPerson() {
      this.$http.common
        .getDutyPerson({ businessZoneId: this.filterForm.businessZoneId })
        .then((res) => {
          this.dutyPersonList = res.data;
        });
    },
    // 账号更新业务员
    getCurrentDutyPerson() {
      this.$http.common
        .getDutyPerson({ businessZoneId: this.currentData.businessZoneId })
        .then((res) => {
          this.currentDutyPersonList = res.data;
        });
    },
    // 查询
    handleFilter() {
      this.pagination.currentPage = 1;
      this.getCtCountyAccountPage();
    },
    //重置
    handleReset(formName) {
      this.$refs[formName].resetFields();
      this.checkedZone = [];
      setTimeout(() => {
        this.handleFilter();
      }, 500);
    },
    /**
     * @Description: 停用/启用
     */
    async handleStatus(row, e) {
      let statusFlag = row.statusFlag == 20 ? 10 : 20;
      let statusFlagName = statusFlag == 10 ? "启用" : "停用";
      let { masterId } = row;
      let target = e.target;
      if (target.nodeName == "SPAN") {
        target = e.target.parentNode;
      }
      target.blur();
      if (statusFlag == 20) {
        this.$confirm(
          `是否确认${statusFlagName}该账号？`,
          `${statusFlagName}提示`,
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            center: true,
          }
        )
          .then(() => {
            this.updateStatus({ id: masterId, statusFlag });
          })
          .catch(() => {});
      } else {
        this.updateStatus({ id: masterId, statusFlag });
      }
    },
    /**
     * @Description: 启用停用服务
     * @Author: yangsibo
     * @Date: 2022-09-29 16:53:50
     * @param {*} params
     */
    async updateStatus(params) {
      try {
        let { status, data } = await this.$http.insure.updateStatusInsure(
          params
        );
        if (status == 1 && data) {
          this.$message.success(
            params.statusFlag == 10 ? "当前账号已启用" : "当前账号已停用"
          );
          this.getCtCountyAccountPage();
        } else {
          this.$message.error(
            params.statusFlag == 10 ? "当前账号未启用" : "当前账号未停用"
          );
        }
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * @Description: 打开弹窗
     * @Author: yangsibo
     * @Date: 2022-09-29 17:31:12
     * @param {*} row 当前数据
     * @param {*} type 弹窗类型
     * @return {*}
     */
    handleInfo(row, type) {
      this.currentData = JSON.parse(JSON.stringify(row));
      this.currentData.address = `${row.provinceName}>${row.cityName}>${row.areaName}`;
      switch (type) {
        case "update":
          this.getFinanceAccountDetail(
            this.currentData.masterId,
            `${row.provinceName}>${row.cityName}>${row.areaName}`
          );
          break;
        case "reset":
          this.dialogResetVisible = true;
          break;
        default:
          break;
      }
    },
    /**
     * @Description: 重置密码
     * @Author: yangsibo
     * @Date: 2022-09-29 17:03:14
     * @return {*}
     */
    handleResetInfo(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let { masterId, password } = this.currentData;
          try {
            let { status } = await this.$http.insure.updatePasswordInsure({
              id: masterId,
              password,
            });
            if (status == 1) {
              this.$message.success("当前县账号重置密码成功");
              this.dialogResetVisible = false;
            }
          } catch (error) {
            console.log(error);
          }
        } else {
        }
      });
    },
    /**
     * @Description: 获取县账号详情
     * @Author: yangsibo
     * @Date: 2022-09-29 18:08:10
     * @param {*} id 当前县账号ID
     * @return {*}
     */
    async getFinanceAccountDetail(id, address) {
      try {
        let { data } = await this.$http.insure.getInsureAccountDetail({ id });
        this.currentData = data;
        this.getCurrentDutyPerson();
        this.currentData.address = address;
        this.dialogUpdateVisible = true;
      } catch (error) {}
    },
    /**
     * @Description: 保存县账号更新信息
     * @Author: yangsibo
     * @Date: 2022-09-29 17:51:05
     * @param {*} formName 表单名称
     */
    handleSaveInfo(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let {
            masterId,
            mobile,
            contactName,
            subDomain,
            businessZoneId,
            businessPersonId,
            companyName,
            businessAddress,
          } = this.currentData;
          businessZoneId =
            typeof businessZoneId == "string"
              ? businessZoneId
              : businessZoneId[businessZoneId.length - 1];
          try {
            let { status } = await this.$http.insure.updateInsureAccountById({
              id: masterId,
              mobile,
              contactName,
              subDomain,
              businessZoneId,
              businessPersonId,
              companyName,
              businessAddress,
            });
            if (status == 1) {
              this.$message.success("当前县账号修改成功");
              this.dialogUpdateVisible = false;
              this.getCtCountyAccountPage();
            }
          } catch (error) {
            console.log(error);
          }
        } else {
        }
      });
    },
    // 保险机构
    insureAssociate(key, cb) {
      if (key !== "") {
        this.loading = true;
        this.$http.insure
          .queryInsurOreByKey({ key })
          .then(({ data }) => {
            this.loading = false;
            // let arr = data.map( (item,index) => ({name:item,value:index}));
            cb(data); // 渲染回调
          })
          .catch((res) => {
            this.loading = false;
          });
      }
    },
  },
};
